import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-white mt-10 md:mt-14 border-t-4 border-primary-500">
      <div className="max-w-5xl mx-auto px-4 py-12 text-center">
        {/* Marca */}
        <div className="flex flex-col items-center">
          <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center overflow-hidden mb-3">
            <img
              src="https://static.readdy.ai/image/3ac88beca320db2f961147cc19b75475/c966e299d7275505654852a65f959d1a.png"
              alt="Logo Baños Run"
              className="w-full h-full object-cover"
            />
          </div>
          <p className="font-heading text-2xl tracking-wide">BAÑOS RUN 2026</p>
          <p className="text-sm text-white/60 mt-1">
            Campeonato Nacional de Carreras de Calle · Baños de Agua Santa, Ecuador
          </p>
        </div>

        {/* Navegación */}
        <nav className="flex flex-wrap justify-center gap-x-8 gap-y-2 mt-8 text-sm font-semibold">
          <Link to="/inscribirse" className="hover:text-primary-500 transition-colors">Inscripciones</Link>
          <Link to="/recorrido" className="hover:text-primary-500 transition-colors">Recorrido</Link>
          <Link to="/reglamento" className="hover:text-primary-500 transition-colors">Reglamento</Link>
        </nav>

        {/* Contacto */}
        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 mt-5 text-sm text-white/80">
          <a href="https://wa.me/593979102532" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 hover:text-primary-500 transition-colors">
            <i className="ri-whatsapp-line text-base" /> +593 97 910 2532
          </a>
          <span className="text-white/30 hidden sm:inline">·</span>
          <a href="mailto:nestorquinapanta@gmail.com" className="inline-flex items-center gap-1.5 hover:text-primary-500 transition-colors">
            <i className="ri-mail-line text-base" /> nestorquinapanta@gmail.com
          </a>
        </div>

        <p className="text-xs text-white/50 mt-3">Información: Néstor Quinapanta</p>

        {/* Pie */}
        <div className="border-t border-white/10 mt-8 pt-6">
          <p className="text-xs text-white/40">
            Certificado por World Athletics · Organizado por ATEC en coordinación con el GAD Municipal de Baños.
          </p>
          <p className="text-xs text-white/40 mt-1">
            © 2026 Baños Run · Campeonato Nacional de Carreras de Calle. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
